import { render, staticRenderFns } from "./CardProduto.vue?vue&type=template&id=1cf7d458&"
import script from "./CardProduto.vue?vue&type=script&lang=js&"
export * from "./CardProduto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports